import styled from 'styled-components';

import { size } from '../../layout/helpers';
import { inputPlaceholder } from '../../layout/reset';

export const Input = styled.input`
  display: block;
  width: 100%;
  height: ${(props) => props.theme.size.inputHeight};
  padding: 0 ${size(2)};
  margin: 0;
  background-color: transparent;
  background-color: ${(props) => props.theme.color.bg.alt};
  border: 1px solid ${(props) => props.theme.color.border.alt};
  border-radius: 0;
  font-family: ${(props) => props.theme.font.family};
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 16px;
  line-height: ${(props) => props.theme.font.lineHeight.normal};
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-appearance: none;
  touch-action: manipulation;

  &[disabled],
  &[readonly] {
    background-color: ${(props) => props.theme.color.disabled.bg};
    color: ${(props) => props.theme.color.disabled.text};
    cursor: not-allowed;
  }

  ${inputPlaceholder}
`;
